<template>
  <div class="preloading">
    <div class="wrap-preload">
      <div class="text">Emennu</div>
      <div class="cssload-loader"></div>
      <div class="text2">Carregando...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading"
};
</script>

<style></style>
